import {Header} from "./components/header/Header";
import './App.css';
import {Hero} from "./components/hero/Hero";
import {Party} from "./components/party/Party";
import {Slides} from "./components/party/Slides";
import {Gallery} from "./components/gallery/Gallery";
import {GallerySlide} from "./components/gallery/GallerySlide";
import {PhotoZone} from "./components/photo-zone/PhotoZone";
import {SlideZone} from "./components/photo-zone/SlideZone";
import {Reviews} from "./components/reviews/Reviews";
import {ReviewsSlide} from "./components/reviews/ReviewsSlide";
import {Faq} from "./components/faq/Faq";
import {Order} from "./components/order/Order";
import {Footer} from "./components/footer/Footer";
import {Faqs} from "./components/faq/Faqs";
import {Choice} from "./components/сhoice/Choice";
import {Location} from "./components/location/Location";
import {Locations} from "./components/location/Locations";
import {AdvertisementTimerModal} from "./components/modal/advertisement/AdvertisementTimerModal";
import {useState} from "react";
import {CookieConsent} from "./components/cookie/CookieConsent";

export const App = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeModal = () =>{
        setIsModalOpen(false);
    }

  return(
      <>
        <Header/>
        <Hero/>
        <Party slide={Slides()}/>
        <PhotoZone zone={SlideZone()} />
        <Gallery gallery={GallerySlide()}/>
        <Reviews review={ReviewsSlide()}/>
        <Choice/>
        <Location locations={Locations()}/>
        <Faq faq={Faqs()}/>
        <Order/>
        <Footer/>
        {/*<AdvertisementTimerModal isOpen={true} delayMs={5000} onClose={() => closeModal()}/>*/}
        <CookieConsent/>
      </>

  )
}
